import React from "react";
import { ArrowDownIcon } from "Assets";
import Icon from "../Icon/Icon";
import styles from "./IconCircleFrame.module.scss";
import { Loader } from "../Loader";

interface IconFrameProps {
  icon?: React.ElementType;
  onClick?: () => void;
  padding?: string;
  bgColor?: string;
  label?: string;
  withArrow?: boolean;
  isFuncLoading?: boolean;
}

const IconCircleFrame: React.FC<IconFrameProps> = ({
  icon,
  padding,
  bgColor,
  onClick,
  label,
  withArrow,
  isFuncLoading = false,
}) => {
  return (
    <div
      onClick={!isFuncLoading ? onClick : undefined}
      style={{
        padding,
        background: bgColor,
        cursor: isFuncLoading ? "default" : "pointer",
      }}
      className={`${styles.frame} ${isFuncLoading ? styles.loading : ""}`}
    >
      {isFuncLoading ? (
        <Loader />
      ) : (
        <>
          <Icon component={icon} />
          {label && (
            <p className={styles.frame_label}>
              {label} {withArrow && <Icon component={ArrowDownIcon} />}
            </p>
          )}
        </>
      )}
    </div>
  );
};

export default IconCircleFrame;
